<script setup>
import { useI18n } from 'vue-i18n';
import { useSupportTicketFormatters } from '../composables/useSupportTicketFormatters';

defineProps({
  selectedTicket: { type: Object, required: true },
  selectedStatus: { type: Object, required: true },
  selectedWaiting: { type: Object, required: true },
  selectedSla: { type: Object, default: null },
  selectedSlaStatus: { type: Object, required: true },
});

const { t } = useI18n();
const { localizedDate } = useSupportTicketFormatters();
</script>

<template>
  <div class="flex flex-wrap items-start justify-between gap-3">
    <div class="min-w-0">
      <p class="text-[16px] font-semibold text-lais-text">
        {{ selectedTicket.subject }}
      </p>
      <p class="mt-1 text-[12px] text-lais-text-muted">
        {{
          t('SUPPORT_TICKETS.DETAIL.CREATED_BY', {
            name:
              selectedTicket.created_by?.name || selectedTicket.requester_name,
            date: localizedDate(selectedTicket.created_at),
          })
        }}
      </p>
    </div>
    <div class="flex flex-wrap gap-2">
      <span
        class="rounded-full px-2.5 py-1 text-[11px] font-semibold"
        :class="selectedStatus.className"
      >
        {{ selectedStatus.label }}
      </span>
      <span
        class="rounded-full px-2.5 py-1 text-[11px] font-semibold"
        :class="selectedWaiting.className"
      >
        {{ selectedWaiting.label }}
      </span>
    </div>
  </div>

  <section
    v-if="selectedSla"
    class="grid gap-2 rounded-lais border border-lais-border-soft bg-white px-4 py-3"
  >
    <div class="flex items-center justify-between gap-3">
      <h3 class="text-[13px] font-semibold text-lais-text">
        {{ t('SUPPORT_TICKETS.SLA.TITLE') }}
      </h3>
      <span
        class="rounded-full px-2.5 py-1 text-[11px] font-semibold"
        :class="selectedSlaStatus.className"
      >
        {{ selectedSlaStatus.label }}
      </span>
    </div>
    <p class="text-[12px] text-lais-text-muted">
      {{
        selectedSla.first_responded_at
          ? t('SUPPORT_TICKETS.SLA.FIRST_RESPONDED', {
              date: localizedDate(selectedSla.first_responded_at),
            })
          : t('SUPPORT_TICKETS.SLA.FIRST_RESPONSE_DUE', {
              date: localizedDate(selectedSla.first_response_due_at),
            })
      }}
    </p>
    <p class="text-[12px] text-lais-text-muted">
      {{
        t('SUPPORT_TICKETS.SLA.RESOLUTION_DUE', {
          date: localizedDate(selectedSla.resolution_due_at),
        })
      }}
    </p>
  </section>
</template>
